export default __webpack_public_path__ + "static/media/gift-3.3056c380.svg";